import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "split-table-layout" }
const _hoisted_8 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_9 = { class: "tab-title_left fl" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CommandRender = _resolveComponent("CommandRender")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_ContactList = _resolveComponent("ContactList")!
  const _component_MarketFee = _resolveComponent("MarketFee")!
  const _component_TraceInfo = _resolveComponent("TraceInfo")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_InvoiceFormCom = _resolveComponent("InvoiceFormCom")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilterField, (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: field.fieldKey,
                  class: "filter-box"
                }, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(field.fieldName), 1),
                  (field.componentType === 'el-input')
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        modelValue: _ctx.listQuery[field.fieldKey],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.listQuery[field.fieldKey]) = $event),
                        style: {"width":"200px"},
                        size: _ctx.t('table.btnSize'),
                        class: "filter-item",
                        clearable: "",
                        onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "size", "onKeyup"]))
                    : (field.componentType === 'el-select')
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 1,
                          filterable: true,
                          modelValue: _ctx.listQuery[field.fieldKey],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.listQuery[field.fieldKey]) = $event),
                          class: "filter-item",
                          placeholder: "",
                          clearable: "",
                          size: _ctx.t('table.btnSize'),
                          onFocus: ($event: any) => (_ctx.handleFilterFocus(field)),
                          onChange: _ctx.handleFilter
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.handleFilterOptions(field), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.mark,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "size", "onFocus", "onChange"]))
                      : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_4, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleCommand('incoice')))
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode(" 发票申请 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_INVOICE` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[15] || (_cache[15] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: el => { if (el) _ctx.tableListRef[0] = el },
            dataList: _ctx.list,
            columnAllData: _ctx.columnAllData?.filter((item) => !_ctx.hiddenColumnLabels.some((labelValue) => item.fieldName === labelValue)),
            tableName: _ctx.TableName,
            permissionName: _ctx.permissionName,
            showSelection: true,
            isShowPagination: false,
            handleDefaultWidth: 120,
            highlightCurrentRow: true,
            layoutHeight: true,
            newHpx: _ctx.newHpx,
            canRefresh: false,
            canChangeColumn: false,
            canCommand: false,
            style: {"height":"100%","overflow":"hidden"},
            onRowClick: _ctx.handleRowClick,
            onCommandChange: _ctx.handleCommand
          }, {
            "operation-action": _withCtx((scope) => [
              _createVNode(_component_CommandRender, {
                scopeRow: scope.row,
                codeList: _ctx.btnList,
                permissionName: _ctx.permissionName,
                onCommandChange: _ctx.handleCommand
              }, null, 8, ["scopeRow", "codeList", "permissionName", "onCommandChange"])
            ]),
            _: 1
          }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "newHpx", "onRowClick", "onCommandChange"])), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            class: "mt-20",
            total: _ctx.total,
            currentPage: _ctx.listQuery.page,
            "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.page) = $event)),
            "page-size": _ctx.listQuery.size,
            "page-sizes": _ctx.pageSizes,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            layout: "total, sizes, prev, pager, next"
          }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.total > 0]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_10))
              }), 128))
            ])
          ]),
          (_ctx.activeTab === 1)
            ? (_openBlock(), _createBlock(_component_ContactList, {
                key: 0,
                ref: "ContactList",
                id: _ctx.activeId
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 4)
            ? (_openBlock(), _createBlock(_component_MarketFee, {
                key: 1,
                ref: "MarketFee",
                id: _ctx.activeId,
                marketFeeCanCommand: false
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 3)
            ? (_openBlock(), _createBlock(_component_TraceInfo, {
                key: 2,
                ref: "TraceInfo",
                id: _ctx.activeId,
                api: "business"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible && !_ctx.invoiceVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'business',
          commandState: _ctx.commandState,
          "onUpdate:visibel": _cache[8] || (_cache[8] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "commandState"]))
      : _createCommentVNode("", true),
    (_ctx.invoiceVisible)
      ? (_openBlock(), _createBlock(_component_InvoiceFormCom, {
          key: 1,
          dialogFormVisible: _ctx.invoiceVisible,
          api: 'invoice',
          from: "business",
          selectionBusiness: _ctx.selectionArray,
          selectcCustomerCompanyId: _ctx.selectcCustomerCompanyId,
          selectcCustomerTitleId: _ctx.selectcCustomerTitleId,
          selectoOderTaxRate: _ctx.selectoOderTaxRate,
          "onUpdate:visibel": _cache[10] || (_cache[10] = () => _ctx.invoiceVisible = false),
          onSubmit: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleInvoiceSubmit(_ctx.formData)))
        }, null, 8, ["dialogFormVisible", "selectionBusiness", "selectcCustomerCompanyId", "selectcCustomerTitleId", "selectoOderTaxRate"]))
      : _createCommentVNode("", true),
    (!_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}